import React from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import utils from '../utils'
import Hero from '../components/home/Hero'
import BlogListHome from '../components/home/BlogList'
import ConstructionSection from '../components/home/ConstructionSection'
import HousesList from '../components/home/HousesList'
import { LuCheckCircle2 } from "react-icons/lu";
import image from '../assets/IMAGE01.png'
import Categories from '../components/home/Categories'

const PrecisionSection = () => {
    const features = [
        {
            title: "Expertise",
            desc: "Deep understanding of the construction industry including the Kenyan building Codes and statutory requirements.",
        },
        {
            title: "Transparency",
            desc: "Detailed BoQ’s and Work programs that eliminate guesswork and hidden costs.",
        },
        {
            title: "Modern Standards",
            desc: "Leveraging the latest industry software to bring the project to life long before construction commences.",
        },
    ];

    return (
        <section className="py-24 container mx-auto px-3">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
                <div className="relative">
                    <div className="absolute -top-4 -left-4 w-24 h-24 bg-primary/10 rounded-full blur-3xl"></div>
                    <img
                        className="w-full aspect-square object-cover rounded-2xl shadow-2xl relative z-10"
                        src={image}
                        alt="Consultant reviewing blueprints"
                    />
                    <div className="absolute -bottom-6 -right-6 p-8 bg-primary rounded-xl text-white shadow-xl z-20 hidden md:block">
                        <p className="text-3xl font-black italic">Quality First.</p>
                    </div>
                </div>

                <div>
                    <h2 className="text-4xl font-black font-headline mb-8 text-on-surface">
                        Precision in Every Detail
                    </h2>

                    <div className="space-y-6">
                        {features.map((feature, index) => (
                            <div key={index} className="flex gap-4">
                                <div className="flex-shrink-0 w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center text-primary">
                                    <LuCheckCircle2 className="text-xl" />
                                </div>
                                <div>
                                    <h4 className="font-bold text-lg mb-1">{feature.title}</h4>
                                    <p className="text-on-surface-variant">
                                        {feature.desc}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <button
                        className="mt-10 px-8 py-4 bg-primary text-white font-bold rounded-xl hover:bg-primary-container transition-all">
                        Learn More About Us
                    </button>
                </div>
            </div>
        </section>
    );
};

const ReadyToStartSection = (props) => {
    return (
        <section className="py-20 px-3">
            <div className="container mx-auto px-3 bg-gradient-to-br from-primary to-inverse-surface rounded-3xl p-12 md:p-20 text-center relative overflow-hidden shadow-2xl">
                <div
                    className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none"
                    style={{ backgroundImage: "url('https://www.transparenttextures.com/patterns/carbon-fibre.png')" }}
                ></div>

                <div className="relative z-10">
                    <h2 className="text-4xl md:text-5xl font-black text-white mb-6">
                        Ready to Start Your Project?
                    </h2>

                    <p className="text-xl text-white/80 mb-10 max-w-2xl mx-auto">
                        Whether it's a dream home or a commercial complex, our team of expert
                        consultants is here to bring your vision to life with precision and care.
                    </p>

                    <div className="flex flex-wrap justify-center gap-4">
                        <button
                            onClick={() => props.openModal()}
                            className="px-10 py-5 bg-white text-primary font-black rounded-xl shadow-xl hover:bg-gray-100 transition-all active:scale-95">
                            Request Custom Plan
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
};


function HomePage(props) {
    const url = window.location.href
    function openModal() {
        const openBtn = document.getElementById("contact-modal-open-btn")
        openBtn.click()
    }
    return (
        <HelmetProvider>
            <Helmet>
                <title>Home - {utils.siteName}</title>
                <link rel="canonical" href={url} />
            </Helmet>

            <div className=''>
                <Hero />
            </div>
            <div className="">
                <ConstructionSection openModal={openModal} />
            </div>
            <Categories/>
            <div className="px-3">
                <HousesList />
            </div>
            <PrecisionSection />
            <div className="px-3">
                <BlogListHome />
            </div>
            <div className="">
                <ReadyToStartSection openModal={openModal} />
            </div>

        </HelmetProvider>
    )
}

export default HomePage